// PWA registration and lifecycle handling
export const registerPWA = () => {
  if ('serviceWorker' in navigator) {
    // Wait for the 'load' event to not block other work
    window.addEventListener('load', async () => {
      // Check if we're on localhost
      const isLocalhost = Boolean(
        window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
      );

      try {
        // Import the virtual module generated by vite-plugin-pwa
        const { registerSW } = await import('virtual:pwa-register');
        
        // Register the service worker with a periodic check for updates
        const updateSW = registerSW({
          onNeedRefresh() {
            if (confirm('New version available! Would you like to update?')) {
              updateSW();
            }
          },
          onOfflineReady() {
            console.log('App ready to work offline');
          },
          immediate: true
        });

        // Optional: Handle push notifications
        if ('PushManager' in window) {
          try {
            const registration = await navigator.serviceWorker.ready;
            const subscription = await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: process.env.VITE_VAPID_PUBLIC_KEY
            });
            
            // Send the subscription to your server
            // await sendSubscriptionToServer(subscription);
          } catch (err) {
            console.log('Push subscription error:', err);
          }
        }

        // Log success in development
        if (isLocalhost) {
          console.log('Service Worker registered successfully');
        }
      } catch (error) {
        if (isLocalhost) {
          console.error('Service Worker registration failed:', error);
        }
      }
    });

    // Handle offline/online status
    window.addEventListener('online', () => {
      console.log('Application is online');
    });

    window.addEventListener('offline', () => {
      console.log('Application is offline');
    });
  }
};

// Optional: Handle PWA lifecycle events
export const handlePWALifecycle = () => {
  // Handle PWA installation
  window.addEventListener('beforeinstallprompt', (event) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    event.preventDefault();
    
    // Store the event for later use
    window.deferredPrompt = event;
    
    // Optionally show your own install button
    // showInstallButton();
  });

  // Handle PWA installation completion
  window.addEventListener('appinstalled', () => {
    // Clear the deferredPrompt
    window.deferredPrompt = null;
    
    // Optionally hide your install button
    // hideInstallButton();
    
    console.log('PWA installed successfully');
  });
}; 